import { hasValue } from "../../../utils/functions.js";

import TableList from "../../sub-components/Generic/TableList/TableList.vue";

export default {
  name: "CustomerServiceCategory",
  components: {
    TableList
  },
  data() {
    return {
      headers: [
        {label:'Código', field:'Code'},
        {label:'Nome', field:'Name', classHeader:'text-left', classField:'text-left'}
      ],
      permissionIsAuthorize: 'CustomerServiceCategory',
      modalTitle: "Nova Categoria do Atendimento ao Cliente",
      countFilter: 0,
      itemList: [],
      filter: {
        Id: null,
        Code: null,
        Name: null,
        IsExcluded: false
      },
      idField: 0,
      formField: {
        Code: null,
        Name: null
      },
      isSeeing: false,
      loading: false,
      pOpened: null,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      validatedFieldForm: false
    };
  },
  mounted() {
    this.ListCustomerServiceCategory();
  },
  methods: {
    OpenField(item, index, eventName) {
      this.validatedFieldForm = false;
      this.ResetFormField();

      if (eventName == 'Update') {
        // Edit
        this.pOpened = index;
        this.idField = item.Code;
        this.isSeeing = false;
        this.modalTitle = "Editar Campo";
        this.GetCustomerServiceCategory();
      } else if (eventName == 'Add') {
        // Add new
        this.pOpened = null;
        this.isSeeing = false;
        this.modalTitle = "Nova Categoria do Atendimento ao Cliente";
        this.ResetFormField();
      } else {
        // View
        this.pOpened = index;
        this.idField = item.Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes do Campo";
        this.GetCustomerServiceCategory();
      }
      this.$bvModal.show("mFormField");
    },
    
    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },

    Filter() {
      this.$bvModal.hide("mFilter");
      this.ListCustomerServiceCategory();
    },

    ResetFilter() {
      this.filter = {
        Id: null,
        Code: null,
        Name: null,
        IsExcluded: false
      };
      this.ListCustomerServiceCategory();
    },

    ResetFormField() {
      this.formField = {
        Code: null,
        Name: null
      };
    },

    SaveField() {
      this.validatedFieldForm = true;
      this.$refs.FieldValidationForm.validate().then(isValid => {
        if (isValid) {
          this.loading = true;
          this.isSeeing = true;

          if (this.pOpened == null) {
            // Add
            this.AddCustomerServiceCategory();
          } else {
            // Update
            this.UpdateCustomerServiceCategory();
          }
        }
      });
    },

    AddCustomerServiceCategory() {
      this.$store
        .dispatch("AddCustomerServiceCategory", this.formField)
        .then(() => {
          this.$makeToast("O campo foi cadastrado com sucesso.","success","Campo cadastrado");
          this.ListCustomerServiceCategory();
          this.$bvModal.hide("mFormField");
        })
        .catch(error => {
          this.$makeToast("Tente novamente mais tarde.","danger","Erro ao criar campo",error);
        })
        .finally(() => {
          this.loading = false;
          this.isSeeing = false;
        });
    },

    UpdateCustomerServiceCategory() {
      this.$store.dispatch("UpdateCustomerServiceCategory", this.formField)
        .then(() => {
          this.$makeToast("O Campo foi atualizado com sucesso.","success","Campo atualizado");
          this.ListCustomerServiceCategory();
          this.$bvModal.hide("mFormField");
        })
        .catch(error => {
          this.$makeToast("Erro ao atualizar campo, tente novamente.","danger","Erro ao atualizar campo",error);
        })
        .finally(() => {
          this.loading = false;
          this.isSeeing = false;
        });
    },

    GetCustomerServiceCategory() {
      if (this.idField != 0) {
        this.loading = true;
        this.$store.dispatch("GetCustomerServiceCategory", { id: this.idField })
          .then(response => {
            this.formField = response;
          })
          .catch(error => {
            this.$makeToast("Um erro ocorreu ao carregar o campo","danger","Erro ao carregar o campo",error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    ListCustomerServiceCategory() {
      this.loading = true;
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.IsExcluded)) this.countFilter++;
      let data = {
        ...this.pagination,
        "Object.Id": this.filter.Id,
        "Object.Code": this.filter.Code,
        "Object.Name": this.filter.Name,
        "Object.IsExcluded": this.filter.IsExcluded
      };
      delete data.TotalItems;
      this.$store.dispatch("ListCustomerServiceCategory", data)
        .then(response => {
          this.itemList = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao listar os campos. Tente novamente.",
                          "danger","Erro ao listar os Campos",error);
        })
        .finally(() => (this.loading = false));
    },

    DeleteCustomerServiceCategory(id) {
      this.$store.dispatch("DeleteCustomerServiceCategory", { id: id })
        .then(() => {
          this.$makeToast("O Campo foi removido com sucesso.","success","Campo removido");
          this.ListCustomerServiceCategory();
          this.$bvModal.hide("mFormField");
        })
        .catch(error => {
          this.$makeToast("Tente novamente mais tarde.","danger","Erro ao remover Campo",error);
        });
    },

    ConfirmDeleteCustomerServiceCategory(item, index, eventName) {
      this.$makeMsgBox("Você tem certeza que deseja remover " + item.Name + " ?",
                       "Confirmar",this.DeleteCustomerServiceCategory, item.Id);
    },

    preventDecimal(e) {
      if (e.code == "Comma" || e.code == "Period" || e.code == "Minus") {
        e.preventDefault();
      }
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/pages/CustomerServiceCategory/CustomerServiceCategory.js